import { Reporte } from "../../components/Reporte"

export const ClienteRepPj = () => {
    return (
        <Reporte url="ficha/reporte-buscar-clientepj" uindex="ficha/reporte-index-clientepj" nameReport="reporte-cliente-pj.xlsx" />
    )
}
